import { trackAddToCart } from '../lib/pixel'
import type { Bundle } from '../types/blackout'

/** Fire the Meta AddToCart event, then send the customer to Shopify checkout. */
export function goToCheckout(bundle: Bundle) {
  trackAddToCart({
    value: bundle.price,
    contents: { bundle: bundle.id, quantity: bundle.count },
  })
  window.location.href = bundle.cartUrl
}

/** Buy Now for a number of packs: fire AddToCart, then go to that pack's checkout link. */
export function buyNow(bundle: Bundle, packs: number, url: string) {
  trackAddToCart({
    value: bundle.price * packs,
    contents: { bundle: bundle.id, quantity: bundle.count * packs },
  })
  openCheckout(url)
}

/**
 * Shopify checkout refuses to load inside an iframe (like the editor preview),
 * so navigate the top window. If the browser blocks that, open a new tab.
 */
function openCheckout(url: string) {
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = url
      return
    }
    window.location.href = url
  } catch {
    const tab = window.open(url, '_blank', 'noopener')
    if (!tab) window.location.href = url
  }
}
